const API_BASE_URL = (
  process.env.REACT_APP_ANINA_AUTH_API_URL || "http://localhost:8000"
).replace(/\/$/, "");

const CSRF_INTENT = "anina-auth-v1";

async function readJson(response) {
  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  if (!response.ok) {
    const detailPayload = payload?.detail;
    const detail =
      typeof detailPayload === "string"
        ? detailPayload
        : detailPayload?.message || "Alpaca Paper AutoTrade request failed.";

    const requestError = new Error(detail);
    requestError.status = response.status;
    requestError.providerRequestId =
      payload?.provider_request_id ||
      detailPayload?.provider_request_id ||
      null;
    throw requestError;
  }

  return payload;
}

async function paperAutoRequest(path, options = {}) {
  const method = options.method || "GET";
  const mutation = method !== "GET";

  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: "include",
    ...options,
    headers: {
      Accept: "application/json",
      ...(mutation
        ? {
            "Content-Type": "application/json",
            "X-CSRF-Intent": CSRF_INTENT,
          }
        : {}),
      ...(options.headers || {}),
    },
  });

  return readJson(response);
}

export function getPaperAutoTradeAccount() {
  return paperAutoRequest("/paper-autotrade/account");
}

export function getPaperAutoTradePositions() {
  return paperAutoRequest("/paper-autotrade/positions");
}

export function getPaperAutoTradeOrders(status = "open", limit = 50) {
  const query = new URLSearchParams({
    status_filter: String(status),
    limit: String(limit),
  });
  return paperAutoRequest(
    `/paper-autotrade/orders?${query.toString()}`,
  );
}

export function getPaperAutoTradeOrder(orderId) {
  return paperAutoRequest(
    `/paper-autotrade/orders/${encodeURIComponent(orderId)}`,
  );
}

export function submitPaperAutoTradeOrder(order) {
  return paperAutoRequest("/paper-autotrade/orders", {
    method: "POST",
    body: JSON.stringify(order),
  });
}
